import { Modal, ModalHeader } from 'src/shared/design-system/Modal';
import { TopShefShefHatIcon } from './Icons';

interface TopShefInfoModalProps {
  isShowing: boolean;
  onClose: () => void;
}

export const TopShefInfoModal = ({ isShowing, onClose }: TopShefInfoModalProps) => (
  <Modal isShowing={isShowing} onClose={onClose} size='lg' showCloseButton>
    <ModalHeader>
      <div className='flex items-baseline'>
        <TopShefShefHatIcon className='mr-2 w-5 text-radish-200' />
        Top Shef
      </div>
    </ModalHeader>
    <p className='text-base text-neutral-700'>
      Top Shefs have an excellent track record of providing high quality meals - they have excellent reviews,
      competitive pricing and a lot of loyal customers!
    </p>
  </Modal>
);
